export default __webpack_public_path__ + "static/media/HelveticaComp.0555bf1e.ttf";